import {FC, useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {ActionIcon} from 'src/components'
import {useAppDispatch} from 'src/redux/hooks'
import {
  IOrder,
  setAttachmentType,
  setAttachments,
  setIsDownloadOnly,
  setOrder,
  setShowAttachmentModal,
} from 'src/redux/slices/orderSlices'
import {fetchAttachments} from 'src/services/fetcher'
import {IFetchAttacmentsParams} from 'src/services/types'

interface ShowAttachmentButtonProps {
  // item: IOrder
  item: any
  attachment_type: IFetchAttacmentsParams['attachment_type']
  isDownloadOnly: boolean
}

export const ShowAttachmentButton: FC<ShowAttachmentButtonProps> = ({
  item,
  attachment_type,
  isDownloadOnly,
}) => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  const [isLoading, setIsLoading] = useState(false)

  const handleClick = useCallback(async () => {
    try {
      setIsLoading(true)
      dispatch(setOrder(item))
      dispatch(setAttachmentType(attachment_type))
      dispatch(setIsDownloadOnly(isDownloadOnly))

      if (attachment_type === 'amandemen') {
        const [orderItems, amandements] = await Promise.all([
          await fetchAttachments({
            attach_parent: item?.id,
            attachment_type: 'order-item',
          }),
          await fetchAttachments({
            attach_parent: item?.amendment_orders[0]?.id,
            attachment_type: 'amandemen',
          }),
        ])

        const {data: orderItemsData, status: orderItemsStatus} = orderItems
        const {data: amandementsData, status: amandementsStatus} = amandements

        if (orderItemsStatus !== 200 || amandementsStatus !== 200) {
          dispatch(setAttachments([]))
          return
        }

        const attachments = orderItemsData.data.concat(amandementsData.data)
        dispatch(setAttachments(attachments))
        dispatch(setShowAttachmentModal(true))
        return
      }

      const {data, status} = await fetchAttachments({
        attach_parent: item?.id,
        attachment_type,
      })

      if (status !== 200) dispatch(setAttachments([]))
      else dispatch(setAttachments(data.data))
      dispatch(setShowAttachmentModal(true))
    } catch (error) {
      dispatch(setAttachments([]))
    } finally {
      setIsLoading(false)
    }
  }, [attachment_type])

  return (
    <ActionIcon
      className='me-1'
      title={t('order-lampiran')}
      iconPath='/media/icons/duotune/archive-fill.svg'
      isLoading={isLoading}
      onClick={handleClick}
    />
  )
}

ShowAttachmentButton.defaultProps = {
  isDownloadOnly: false,
}
